module.exports = __webpack_public_path__ + "img/icon-download.e1c27d8c.svg";